import styles from "./Pagination.module.css"
import { ReactComponent as ChevronIcon } from "../assets/images/icons/ic-chevron.svg"

const Pagination = ({ page = 0, total, per, group = 5, onChange = () => { }, loading = false, hasNextPage, itemCount = 0 }) => {
  const cursorMode = typeof hasNextPage === "boolean"
  const count = Math.max(0, Number(total) || 0)
  const size = Number(per)
  const pages = Number.isFinite(size) && size > 0 ? Math.ceil(count / size) : 0
  const current = cursorMode ? Math.max(0, Number(page) || 0) : Math.min(Math.max(0, Number(page) || 0), Math.max(0, pages - 1))
  const windowSize = Math.min(7, Math.max(1, Math.floor(Number(group) || 1)))
  const start = Math.max(0, Math.min(current - Math.floor(windowSize / 2), pages - windowSize))
  const visible = new Set(pages > 0 ? [0, pages - 1] : [])
  for (let i = start; i < Math.min(start + windowSize, pages); i++) visible.add(i)
  const items = []
  let previous = -1
  Array.from(visible).sort((a, b) => a - b).forEach(value => {
    if (previous >= 0 && value - previous > 1) items.push(`gap-${value}`)
    items.push(value)
    previous = value
  })
  const changePage = value => {
    const validPage = cursorMode
      ? value === current - 1 || (value === current + 1 && hasNextPage)
      : value < pages
    if (!loading && value !== current && value >= 0 && validPage) onChange(value)
  }

  return (
    <nav className={styles.container} aria-label="Paginazione" aria-busy={loading}>
      <span className={styles.summary} aria-live="polite">
        {loading ? 'Caricamento…' : cursorMode ? (itemCount > 0 ? `${(current * size + 1).toLocaleString('it-IT')}–${(current * size + itemCount).toLocaleString('it-IT')} risultati` : 'Nessun risultato') : pages > 0 ? `${(current * size + 1).toLocaleString('it-IT')}–${Math.min((current + 1) * size, count).toLocaleString('it-IT')} di ${count.toLocaleString('it-IT')} risultati` : 'Nessun risultato'}
      </span>
      <div className={styles.controls}>
        <button type="button" className={styles.arrow} aria-label="Pagina precedente" disabled={loading || current <= 0 || (!cursorMode && !pages)} onClick={() => changePage(current - 1)}>
          <ChevronIcon className={styles.back} aria-hidden="true" />
        </button>
        <div className={`${styles.pages} ${cursorMode || group === 0 ? styles.hidden : ''}`}>
          {items.map(value => typeof value === 'string' ? <span key={value} className={styles.ellipsis} aria-hidden="true">…</span> :
            <button type="button" key={value} className={`${styles.page} ${value === current ? styles.selected : ''}`} aria-label={`Pagina ${value + 1}`} aria-current={value === current ? 'page' : undefined} disabled={loading} onClick={() => changePage(value)}>{value + 1}</button>
          )}
        </div>
        <span className={`${styles.compact} ${cursorMode || group === 0 ? styles.alwaysVisible : ''}`}>{cursorMode ? `Pagina ${current + 1}` : `Pagina ${pages ? current + 1 : 0} di ${pages}`} </span>
        <button type="button" className={styles.arrow} aria-label="Pagina successiva" disabled={loading || (cursorMode ? !hasNextPage : !pages || current >= pages - 1)} onClick={() => changePage(current + 1)}>
          <ChevronIcon className={styles.forward} aria-hidden="true" />
        </button>
      </div>
    </nav>
  )
}

export default Pagination
